import api from 'config/Api/Api';
import { formatFormDataBody } from 'utils';

const baseEndpoint = 'v1/media-audio';

export default {
  getMediaAudios( params ) {
    return api.get( baseEndpoint, params );
  },

  saveMediaAudio( data ) {
    return api.post( baseEndpoint, formatFormDataBody( data ) );
  },

  deleteMediaAudio( id ) {
    return api.delete( `${baseEndpoint}/${id}` );
  },
};
